import { render } from "./list.vue?vue&type=template&id=c1f88b52&scoped=true&ts=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"

import "./list.vue?vue&type=style&index=0&id=c1f88b52&lang=scss&scoped=true"
import "./list.vue?vue&type=style&index=1&id=c1f88b52&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1f88b52"]])

export default __exports__